import React from 'react'
import PropTypes from 'prop-types'
import DashboardLayout from '../DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Menu, Pagination } from 'antd'
import { Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'

const InternalMessageLayout = props => {
  const {
    children,
    title,
    selectedKey,
    linkToInternalMessageRecieve,
    linkToInternalMessageSend,
    total,
    current,
    pageSize,
    onChangePagination,
  } = props

  return (
    <DashboardLayout>
      {title}
      <ContentBlockWrapper>
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          style={{ marginBottom: 16 }}>
          <Menu.Item key="receive">
            <Link to={linkToInternalMessageRecieve}>Tin nhắn đến</Link>
          </Menu.Item>
          <Menu.Item key="send">
            <Link to={linkToInternalMessageSend}>Tin nhắn đi</Link>
          </Menu.Item>
        </Menu>
        {children}
        {total > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 16,
            }}>
            <Pagination
              total={total || 0}
              current={current || 1}
              pageSize={pageSize || 10}
              onChange={onChangePagination}
              hideOnSinglePage={true}
              showSizeChanger={false}
              showLessItems
            />
          </div>
        )}
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

InternalMessageLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  selectedKey: PropTypes.string,
  total: PropTypes.number,
  current: PropTypes.number,
  pageSize: PropTypes.number,
  onChangePagination: PropTypes.func,
}

export default inject('aclStore')(observer(InternalMessageLayout))
